const downloads = {
  title: "Загрузки",
  gamOnline: "GAM Онлайн",
  reminderTitle: "Скачайте GAM Command Center",
  reminderSubtitle: "Быстрый доступ с любого устройства",
  website: "Мобильный сайт",
  desktop: "Приложение для ПК",
  android: "Android",
  iphone: "iPhone",
  later: "Позже",
} as const;
export default downloads;
